var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4001_6575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1507 16.1882C32.1507 25.2235 24.9978 32.3765 15.9625 32C7.30364 32 0.150696 24.8471 0.150696 15.8118C0.150696 7.15294 7.30364 0 16.3389 0C24.9978 0 32.1507 7.15294 32.1507 16.1882ZM16.3389 22.9647C18.5978 22.9647 21.233 22.5882 23.4919 22.5882C24.9978 22.5882 25.7507 21.8353 25.7507 20.3294C25.7507 17.6941 25.7507 14.6824 25.7507 12.0471C25.7507 10.1647 24.9978 9.41176 23.1154 9.41176C18.5978 9.41176 14.0801 9.41176 9.56246 9.41176C7.68011 9.41176 6.5507 10.1647 6.5507 12.0471C6.5507 14.6824 6.5507 17.3176 6.5507 19.9529C6.5507 21.8353 7.30364 22.5882 9.18599 22.5882C11.4448 22.9647 13.7036 22.9647 16.3389 22.9647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4566 13.1765C15.9625 13.9295 17.4683 15.0589 19.3507 15.8118C17.4683 16.9412 15.9625 18.0706 14.4566 18.8236V13.1765Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4001_6575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.150696)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.201f7f6a0a93b9f1c2775be033d9a3e0.svg";
export { ForwardRef as ReactComponent };